// @flow
import { message } from 'antd';

export const showSkippedToast = ({
  action,
  result,
  scheduleTypes,
}: {
  action: string,
  result: {
    participants: Array<any>,
    skipped: Array<number>,
    requestedTypeIds: Array<number>,
  },
  scheduleTypes: Array<{ id: number, type: string }>,
}) => {
  const { participants, skipped, requestedTypeIds } = result;
  const updatedCount = (participants || []).length;
  const requestedCount = (requestedTypeIds || []).length;
  // Inline capitalization — only two callers ('updated', 'assigned'),
  // not worth pulling in a generic utility.
  const verb = action.charAt(0).toUpperCase() + action.slice(1);

  if (skipped && skipped.length > 0) {
    const skippedNames = skipped
      .map((id) => scheduleTypes.find((t) => t.id === id)?.type)
      .filter(Boolean)
      .join(', ');
    message.warning(
      `${verb} ${updatedCount} of ${requestedCount} schedule types. ` +
        `${skippedNames} were skipped — those schedule types may not be ready yet, or the participant isn't on them. Open the tabs to verify, then retry if needed.`,
      8
    );
  } else {
    message.success(
      `${verb} ${updatedCount} schedule type${updatedCount === 1 ? '' : 's'}`
    );
  }
};
